import { actions } from "../slice.js";
import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/i18n/thunks/get-country.ts
var getCountry = createAsyncThunk(thunkTypes.GET_COUNTRY, async (_, { extra, dispatch }) => {
	const country = extra.country;
	dispatch(actions.updateCountry({ country }));
	return country;
});
//#endregion
export { getCountry };

//# sourceMappingURL=get-country.js.map